import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpUtilsService } from 'app/core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from 'app/core/_base/crud';
import { HcDangKyTiepKhachModel } from '../hc-dang-ky-tiep-khach-model/hc-dang-ky-tiep-khach.model';

const API_ROOT_URL = environment.ApiRoot + '/hc_dangkytiepkhach';

@Injectable()
export class HC_DangKyTiepKhachService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import: BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }

	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.post<any>(API_ROOT_URL + '/HcDangKyTiepKhach_List', httpParams, { headers: httpHeaders });
	}
	getDataApproval(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/HcDangKyTiepKhach_ListApproval', { headers: httpHeaders, params: httpParams });

	}
	getHC_DangKyTiepKhachById(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/HcDangKyTiepKhach_Detail?IdTk=${itemId}`, { headers: httpHeaders });
	}
	updateTinhTrang(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/HcDangKyTiepKhachTinhTrang_Update`;
		return this.http.post<any>(url, item, { headers: httpHeaders });
	}
	createHC_DangKyTiepKhach(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<HcDangKyTiepKhachModel>(API_ROOT_URL + '/HcDangKyTiepKhach_Insert', item, { headers: httpHeaders });
	}
	updateHC_DangKyTiepKhach(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<HcDangKyTiepKhachModel>(API_ROOT_URL + '/HcDangKyTiepKhach_Update', item, { headers: httpHeaders });
	}
	DM_PhongBan_Tree(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + '/danhmuc/DM_PhongBan_Tree', { headers: httpHeaders });
	}
	DM_NhanVien_List(id): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + `/danhmuc/DM_NhanVien_List_ByPhongBan?IdPhongBan=${id}`, { headers: httpHeaders });
	}
	HcDangKyTiepKhach_DP(item: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/HcDangKyTiepKhach_DP?IdTk=${item.IdTk}&IdDP=${item.IdDp}&Tu=${item.TuGio}&Den=${item.DenGio}`, { headers: httpHeaders });
	}
}
